import { lazy } from "react";
import type { RouteRecord } from "vite-react-ssg";
import Layout from "./Layout";
import Index from "./pages/Index";
import { SERVICE_SLUGS } from "./data/service-slugs";
import { ARTICLES } from "./data/articles-loader";
import { GUIDES } from "./data/guides-loader";
import { CASE_SLUGS } from "./data/cases";
import { CONFIRMATION_SLUGS } from "./data/confirmations";
import { BLOG_POSTS } from "./data/blog-loader";
import { REDIRECT_SOURCES } from "./data/redirects";

// Lazy-load every non-home page so the initial bundle stays minimal.
// vite-react-ssg still pre-renders them at build time.
const ServicioPage = lazy(() => import("./pages/ServicioPage"));
const FAQPage = lazy(() => import("./pages/FAQ"));
const NoticiasPage = lazy(() => import("./pages/Noticias"));
const ArticuloPage = lazy(() => import("./pages/Articulo"));
const GuiaPage = lazy(() => import("./pages/Guia"));
const GuiasPage = lazy(() => import("./pages/Guias"));
const TerminosPage = lazy(() => import("./pages/Terminos"));
const CookiesPage = lazy(() => import("./pages/Cookies"));
const PrivacidadPage = lazy(() => import("./pages/Privacidad"));
const PreciosPage = lazy(() => import("./pages/Precios"));
const CasosPage = lazy(() => import("./pages/Casos"));
const CasoDetallePage = lazy(() => import("./pages/CasoDetalle"));
const ContactoPage = lazy(() => import("./pages/Contacto"));
const SobreNosotrosPage = lazy(() => import("./pages/SobreNosotros"));
const AvisoLegalPage = lazy(() => import("./pages/AvisoLegal"));
const ConfirmacionPage = lazy(() => import("./pages/Confirmacion"));
const BlogPage = lazy(() => import("./pages/Blog"));
const BlogArticuloPage = lazy(() => import("./pages/BlogArticulo"));
const NotFound = lazy(() => import("./pages/NotFound"));
const RedirectPage = lazy(() => import("./pages/RedirectPage"));

export const routes: RouteRecord[] = [
  {
    path: "/",
    element: <Layout />,
    entry: "src/Layout.tsx",
    children: [
      { index: true, Component: Index, entry: "src/pages/Index.tsx" },
      // Hard redirects: must come before the dynamic servicios/:slug route.
      { path: "servicios/crm", Component: RedirectPage, entry: "src/pages/RedirectPage.tsx" },
      { path: "servicios/websites", Component: RedirectPage, entry: "src/pages/RedirectPage.tsx" },
      {
        path: "servicios/:slug",
        Component: ServicioPage,
        entry: "src/pages/ServicioPage.tsx",
        getStaticPaths: () => SERVICE_SLUGS.map((s) => `/servicios/${s}`),
      },
      { path: "faq", Component: FAQPage, entry: "src/pages/FAQ.tsx" },
      { path: "noticias", Component: NoticiasPage, entry: "src/pages/Noticias.tsx" },
      {
        path: "noticias/:slug",
        Component: ArticuloPage,
        entry: "src/pages/Articulo.tsx",
        getStaticPaths: () => ARTICLES.map((a) => `/noticias/${a.slug}`),
      },
      { path: "guias", Component: GuiasPage, entry: "src/pages/Guias.tsx" },
      {
        path: "guias/:slug",
        Component: GuiaPage,
        entry: "src/pages/Guia.tsx",
        getStaticPaths: () => GUIDES.map((g) => `/guias/${g.slug}`),
      },
      { path: "terminos", Component: TerminosPage, entry: "src/pages/Terminos.tsx" },
      { path: "cookies", Component: CookiesPage, entry: "src/pages/Cookies.tsx" },
      { path: "privacidad", Component: PrivacidadPage, entry: "src/pages/Privacidad.tsx" },
      { path: "precios", Component: PreciosPage, entry: "src/pages/Precios.tsx" },
      { path: "casos-de-exito", Component: CasosPage, entry: "src/pages/Casos.tsx" },
      {
        path: "casos/:slug",
        Component: CasoDetallePage,
        entry: "src/pages/CasoDetalle.tsx",
        getStaticPaths: () => CASE_SLUGS.map((s) => `/casos/${s}`),
      },
      { path: "contacto", Component: ContactoPage, entry: "src/pages/Contacto.tsx" },
      { path: "sobre-nosotros", Component: SobreNosotrosPage, entry: "src/pages/SobreNosotros.tsx" },
      { path: "aviso-legal", Component: AvisoLegalPage, entry: "src/pages/AvisoLegal.tsx" },
      {
        path: "gracias/:slug",
        Component: ConfirmacionPage,
        entry: "src/pages/Confirmacion.tsx",
        getStaticPaths: () => CONFIRMATION_SLUGS.map((s) => `/gracias/${s}`),
      },
      { path: "blog", Component: BlogPage, entry: "src/pages/Blog.tsx" },
      {
        path: "blog/:slug",
        Component: BlogArticuloPage,
        entry: "src/pages/BlogArticulo.tsx",
        getStaticPaths: () => BLOG_POSTS.map((p) => `/blog/${p.slug}`),
      },
      // 301-style redirects from the old WordPress site.
      // Each source path is pre-rendered with a meta refresh + canonical to target.
      ...REDIRECT_SOURCES.map((src) => ({
        path: src.replace(/^\//, ""),
        Component: RedirectPage,
        entry: "src/pages/RedirectPage.tsx",
      })),
      { path: "*", Component: NotFound, entry: "src/pages/NotFound.tsx" },
    ],
  },
];

export default routes;
